import { useEffect, useState } from 'react';

export interface PagingProps {
  itemCount?: number;
  pageSize?: number;
  page?: number;
  filters?: any[];
}

export default function usePaging(props: PagingProps) {
  const [pageSize, setPageSize] = useState(props.pageSize || 20);
  const [page, setPage] = useState(props.page || 1);
  const [itemCount, setItemCount] = useState(props.itemCount || 0);
  const offset = (page - 1) * pageSize;
  const offsetEnd = offset + pageSize - 1;
  const limit = pageSize;
  const pageCount = Math.ceil(itemCount / pageSize);

  const hasPrev = page > 1;
  const hasNext = page < pageCount;

  const nextPage = () => {
    hasNext && setPage(page + 1);
  };
  const prevPage = () => {
    hasPrev && setPage(page - 1);
  };

  useEffect(() => {
    setPage(1);
  }, props.filters);

  return {
    pageSize,
    page,
    offset,
    offsetEnd,
    pageCount,
    hasPrev,
    hasNext,
    itemCount,
    limit,
    setItemCount,
    setPageSize,
    setPage,
    nextPage,
    prevPage,
  };
}
